module.exports = __webpack_public_path__ + "img/buenpuerto-logo.4030c9bb.svg";